export default {
  'shortenedUrls.title': 'Manage Shortened URLs',

  'shortenedUrls.form.entityDisplayName': 'Entity',
  'shortenedUrls.form.shortenedUrlCode': 'Shortened URL Code',
  'shortenedUrls.form.entityId': 'Entity ID',
  'shortenedUrls.form.redirectUrl': 'Redirect to URL',
  'shortenedUrls.allowedDomains': 'Allowed Domains',
};
